import React from 'react';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { LiliButton } from '@lili/lili-frontend-common';
import Heading from '../../../../generic-components/Heading';
import { VIEWS_MAP } from '../../../../router/constants';
import { ReactComponent as SuccessIcon } from '../../../../assets/icons/svg/colored-icons/ic-colored-success-new.svg';
import { RoleType } from '../../../../types';

interface InviteSuccessProps {
  role: RoleType;
}

export const InviteSuccess = ({ role }: InviteSuccessProps) => {
  const navigate = useNavigate();

  const dataByRole = (() => {
    switch (role) {
      case RoleType.ACCOUNTANT:
        return {
          role: t('inviteEN:INVITE_SUCCESS.ROLE_DESCRIPTION.ACCOUNTANT'),
          daysToExpire: 30,
        };
      case RoleType.ADMIN:
        return {
          role: t('inviteEN:INVITE_SUCCESS.ROLE_DESCRIPTION.ADMIN'),
          daysToExpire: 14,
        };
      default:
        return {
          role: '',
          daysToExpire: 0,
        };
    }
  })();
  return (
    <div className='flex flex-col text-center justify-center items-center w-[416px] px-[40px] py-[40px] rounded-[6px] bg-bw00 fadeIn'>
      <SuccessIcon className='mb-[32px]' />
      <Heading title={t('inviteEN:INVITE_SUCCESS.TITLE')} className='font-metricRSemibold text text-[20px] text-bw08' />
      <Heading
        type='HTML'
        title={t('inviteEN:INVITE_SUCCESS.DESCRIPTION', { role: dataByRole.role, days: dataByRole.daysToExpire })}
        className='font-metricR text text-[14px] text-bw08 mb-[40px]'
      />
      <LiliButton
        id='inviteSuccessCTA'
        title={t('inviteEN:INVITE_SUCCESS.CTA')}
        onClick={() => navigate(`/${VIEWS_MAP.DASHBOARD}`)}
      />
    </div>
  );
};
